<template>
  <div aria-label="Page navigation example" v-if="pages > 1">
    <ul class="pagination">
      <li v-bind:class="{ disabled: currentPage < 2 }" class="page-item">
        <a
          class="page-link"
          @click="onPaginate(currentPage - 1)"
          type="button"
          aria-label="Previous"
        >
          <span aria-hidden="true">&laquo;</span>
        </a>
      </li>
      <li
        class="page-item"
        v-bind:class="{ active: index + 1 === currentPage }"
        v-for="(_, index) in Array(pages).keys()"
        :key="index"
      >
        <a class="page-link" type="button" @click="onPaginate(index + 1)">
          {{ index + 1 }}
        </a>
      </li>

      <li class="page-item" v-bind:class="{ disabled: currentPage >= pages }">
        <a
          class="page-link"
          type="button"
          @click="onPaginate(currentPage + 1)"
          aria-label="Next"
        >
          <span aria-hidden="true">&raquo;</span>
        </a>
      </li>
    </ul>
  </div>
  <!-- <div class="pagination display-4" v-else-if="pages === 0">No records yets...</div> -->
</template>

<script>
export default {
  name: "Pagination",
  props: {
    pages: {
      type: Number,
      required: true,
    },
    currentPage: {
      type: Number,
      required: true,
    },
    onPaginate: {
      type: Function,
      required: true,
    },
  },
};
</script>
<style scoped>
.pagination {
  display: flex;
  flex-direction: row;
  justify-content: center;
}
li.page-item.active .page-link {
  background-color: #8bc34a;
  border-color: #8bc34a;
}
</style>
